import type { RefObject } from "react";
import React from "react";
import {
  ContentWrap,
  DimmedContent,
  EmptyState,
  LoaderWrap,
  LoadMoreSentinel,
  LoadingOverlay,
  Spinner,
} from "./schedule.styled";

type Props = {
  isLoading: boolean;
  isEmpty: boolean;
  emptyText: string;
  isLoadingMore: boolean;
  loadMoreRef: RefObject<HTMLDivElement>;
  hasContent?: boolean;
  isDimmed?: boolean;
  children: React.ReactNode;
};

export const ScheduleViewBody: React.FC<Props> = (props) => {
  const hasContent =
    props.hasContent ?? React.Children.count(props.children) > 0;
  const isDimmed = Boolean(props.isDimmed);

  if (props.isLoading && !hasContent) {
    return (
      <LoaderWrap>
        <Spinner />
      </LoaderWrap>
    );
  }

  if (props.isEmpty && !props.isLoading) {
    return <EmptyState>{props.emptyText}</EmptyState>;
  }

  return (
    <ContentWrap>
      {props.isLoading && (
        <LoadingOverlay>
          <Spinner />
        </LoadingOverlay>
      )}
      <DimmedContent $dimmed={isDimmed}>
        {props.children}
        {props.isLoadingMore && (
          <LoaderWrap>
            <Spinner />
          </LoaderWrap>
        )}
        <LoadMoreSentinel ref={props.loadMoreRef} />
      </DimmedContent>
    </ContentWrap>
  );
};
